//import { useApplicationContext } from "Context";
import hosts from '../config/microServices'
import ApiService from './ApiService'

interface ItokenProps {
  id_token: string
}

const handleToken = {
  getToken: (): string | null => {
    return window.sessionStorage.getItem('token')
  },

  isValid: (token: string): boolean => {
    return decodeToken(token) ? true : false
  },

  setToken: (newToken: string): void => {
    window.sessionStorage.setItem('token', newToken)
  },

  renewToken: async (token: string) => {
    const result = await ApiService().get<ItokenProps>(
      `${hosts.UAA_URL}/revalidate-token`,
    )

    window.sessionStorage.setItem('token', result.data.id_token)
    return result.data.id_token
  },

  cleanToken: () => {
    window.sessionStorage.removeItem('token')
    window.sessionStorage.removeItem('ctx')
  },
}

const decodeToken = (token: string) => {
  if (token !== '') {
    const data = JSON.parse(atob(token.split('.')[1]))
    const currentTime = Date.now() / 1000

    return currentTime > data.exp ? null : data
  } else {
    return null
  }
}

export default handleToken
